<ion-list class="ion-no-padding">


	<ion-item detail="false" lines="none" title="{{'APP_CHECK_UPDATE' | translate }}" *ngIf="IsElectron"
		(click)="OnCheckUpdates($event)">
		<ion-icon slot="start" name="cloud-download" class="ion-no-margin"></ion-icon>
		<ion-label class="app-version ion-text-nowrap" style="margin-left: 32px!important">
			{{ 'APP_CHECK_UPDATE' | translate }}
			<p>Ver. {{ AppVersion }}</p>
		</ion-label>
	</ion-item>

	<ion-item detail="false" class="ion-no-lines" (click)="OnLogout($event)" title="{{'LOGOUT' | translate }}">
		<ion-icon slot="start" name="log-out-outline" class="ion-no-margin"></ion-icon>
		<ion-label style="margin-left: 32px!important">{{'LOGOUT' | translate }}</ion-label>
	</ion-item>

	<ion-item class="app-version-web" detail="false" lines="none" title="{{'APP_CURRENT_VERSION' | translate }}"
		*ngIf="!IsElectron">
		<!-- <ion-icon slot="start" name="information-circle-outline" class="ion-no-margin"></ion-icon> -->
		<ion-label class="app-version ion-text-nowrap ion-text-right" style="margin-left: 32px!important">
			<!-- {{ 'APP_CURRENT_VERSION' | translate }} -->
			<p style="display:inline-block">Ver. {{ AppVersionWeb }}</p>
		</ion-label>

	</ion-item>

</ion-list>